<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import proveedorContratistaAPI from "@/services/standards/crearProveedorContratista/proveedorContratistaAPI";
import Pagination from "@/components/standard/hazardIdentification/hazardPagination2";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import revisionAnualAPI from "../../../services/standards/revisionAnual/revisionAnualAPI";
import identificacionEvaluacionPSAPI from "../../../services/standards/identificacionEvaluacionPS/identificacionEvaluacionPSAPI";
import IdentificacionEvaluacionPagination from "../../../components/standard/identificacionEvaluacionPS/IdentificacionEvaluacionPagination.vue";
/**
 * Form elements component
 */
export default {
  page: {
    title: "Identificación, Evaluación para adquisición de productos y servicios en el SG SST ",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    IdentificacionEvaluacionPagination
  },
  data() {

    return {
      title: "2.9.1 Identificación, Evaluación para adquisición de productos y servicios en el SG SST ",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Identificación, Evaluación para adquisición de productos y servicios en el SG SST ",
          active: true,
        },
      ],

      colaboradorProveedor: [],
      lista: [],
      lastId: 1,
      deleteCount: 0,
      nit: this.$store.getters["company/getCompany"].nit || null,
      file: null,
      submitted: false,
      loading: true,
      acta: null,

      item: null,
      itemStatus: "No cumplido",
      search: "",

      itemData: null,

      roleAdmin: true,

      revisionAnual: {
        file: "datos",
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      list: [
        {
          id: 1,
          name: "Exámenes de ingreso"
        },
        {
          id: 2,
          name: "Exámenes periódicos"
        },
        {
          id: 3,
          name: "examen de retiro"
        }
      ],

      contenidoTexto: null,

      identificacionEvaluacion: {
        providers_contractors_id: null,
        option: null,
        description: null,
        file: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
    };
  },
  methods: {

    validarTexto() {
      if (this.contenidoTexto.length > 200) {
        this.contenidoTexto = this.contenidoTexto.slice(0, 200); // Limitar a 200 caracteres
      } else {
        this.identificacionEvaluacion.description = this.contenidoTexto
      }
    },

    getItemData() {
      ItemAPI.getItems(20)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 20)
        .then(response => {
          this.item = response || null
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch(error => {
          console.log(error)
        })
    },

    changeItemStatus(itemStatus) {
        const itemChange = {
          companies_id: this.companyID,
          item_id: 20,
          status: itemStatus,
        };
        newScoresAPI.calculateScores(itemChange)
          .then((response) => {
            Swal.fire({
              title: "¡Éxito!",
              text: "¡Se ha cambiado el estado del ítem con éxito!",
              icon: "success",
              type: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            setTimeout(() => window.location.reload(), 2000)
          })
          .catch((error) => {
            Swal.fire({
              title: "¡ERROR!",
              text: "¡No se ha actualizado el estado del ítem!",
              icon: "error",
              type: "error",
              confirmButtonClass: "btn btn-confirm mt-2",
            });

            setTimeout(() => window.location.reload(), 2000)
            console.log(error);
          });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
          if (role === 2) {
            this.roleAdmin = false
          }
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },


    async uploadDocument() {
      try {
        let url = "";

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.9.1/${this.lastId}/${this.identificacionEvaluacion.providers_contractors_id}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/2.9.1/${this.lastId}/${this.identificacionEvaluacion.providers_contractors_id}/${this.file.name}`;
        }

        const result = await uploadDocument(url, this.file);
        if (result) {
          this.identificacionEvaluacion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getPC() {
      proveedorContratistaAPI.getAll()
        .then((response) => {
          this.loading = false
          let proveedorC = response.data.data;
          this.colaboradorProveedor = proveedorC
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    async save() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        identificacionEvaluacionPSAPI.save(this.identificacionEvaluacion)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 20,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(40, 20, true)
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload()
                }, 1000)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡No se ha podido registrar!",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    deleteRevision(id) {
      identificacionEvaluacionPSAPI.deleteRevision(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 20,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "Éxito!",
                text: "Se ha sido eliminado con éxito!",
                icon: "success",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getActa() {
      revisionAnualAPI.getActa()
        .then((response) => {
          this.acta = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      identificacionEvaluacionPSAPI.getAll(this.companyID)
        .then((response) => {
          this.lista = response.data.data;
          this.loading = false
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        revisionAnualAPI.getActa()
          .then((response) => {
            this.acta = response;
          })
        const url = this.acta;
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getActa();
    this.getItems();
    this.getList();
    this.getItemData();
    this.getPC();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Tanto el Decreto 1072/2015 como la resolución 0312 de 2019 exigen que las empresas cuenten con
                      especificaciones de SST para las adquisiciones de bienes y servicios, esto implica que la empresa
                      debe definir dependiendo del producto / servicio adquirido, que criterios desde Seguridad y Salud
                      en el Trabajo debe cumplir ese proveedor para ser seleccionado.
                    </p>
                    <p class="text-justify">
                      En el link ESPECIFICACIONES DE SST, se describe algunos de los requisitos de SST para las
                      adquisiciones, los cuales servirán de guía para la empresa.
                    </p>
                    <p class="text-justify">
                      En el ítem 2.10.1 se seleccionará el proveedor y el que sea escogido, deberá crearse con la
                      información aquí solicitada.
                    </p>
                    <p class="text-justify">
                      Se debe subir al aplicativo la evidencia del cumplimiento de las especificaciones de SST del
                      proveedor.
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right m-b-0">

                </div>

              </div>

              <div class="row">
                <div class="col-6">
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3"
                    label="Seleccione proveedor o contratista">
                    <select :disabled="roleAdmin && !getRole('Crear') || !allowAccess()" required class="form-control"
                      v-model="identificacionEvaluacion.providers_contractors_id">
                      <b-form-select-option v-for="item in colaboradorProveedor" :key="item.id" :value="item.id">
                        {{ item.name }} - {{ item.type }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <div class="col-6 text-right m-b-0">
                    <router-link class="mr-2" to="/forms/especificaciones-sst-adquisiciones">ESPECIFICACIONES SST
                      ADQUISICIONES</router-link>
                    <button :disabled="!allowAccess()" @click="
                      goPage(`/forms/estandares/${companyID}/crear-colaborador`)
                      " class="btn btn-primary mx-1">
                      Crear proveedor o contratista
                    </button>
                  </div>

                  <b-form-group class="col-md-6 px-2" label="Descripción del producto o servicio"
                    label-for="trainingDate">
                    <b-form-textarea required maxlength="200" :disabled="!allowAccess() || !getRole('Crear')"
                      id="trainingDate" v-model="contenidoTexto" @change="validarTexto">
                      >
                    </b-form-textarea>
                  </b-form-group>

                  <b-form-group label="" v-slot="{ ariaDescribedby }" class="col-md-2 d-flex flex-row ml-5 mt-4">
                    <b-form-radio :disabled="!getRole('Crear') || !allowAccess()"
                      v-model="identificacionEvaluacion.option" :aria-describedby="ariaDescribedby" name="some-radios"
                      value="Producto">Productos</b-form-radio>
                  </b-form-group>

                  <b-form-group label="" v-slot="{ ariaDescribedby }" class="col-md-2 d-flex flex-row mt-4">
                    <b-form-radio :disabled="!getRole('Crear') || !allowAccess()"
                      v-model="identificacionEvaluacion.option" :aria-describedby="ariaDescribedby" name="some-radios"
                      value="Servicio">Servicios</b-form-radio>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" required type="file" id="file"
                      ref="file" name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">Guardar</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">

                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">Buscar</button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Fecha</th>
                              <th class="text-center align-middle">Proveedor o contratista</th>
                              <th class="text-center align-middle">Descripción</th>
                              <th class="text-center align-middle">Ver archivo</th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.created_at) }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.name }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.description }}
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible
                                  </h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()"
                                    style=" background-color: transparent !important; border: none;" type="button"
                                    @click="gotoDigitalOcean(`${dato.file}`)"> <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>

                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/identificacion-evaluacion-productos-servicios-editar/${dato.id}` }">
                                      Editar</b-dropdown-item>

                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()"
                                      v-on:click="deleteRevision(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                        <IdentificacionEvaluacionPagination ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />

                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>